"use client";

import type { FC, Ref } from "react";
import { AdvicePricing } from "@huub-web/shared";

/**
 * Props interface for AdvicePricesTemplate
 */
export type AdvicePricesTemplateProps = Record<string, never> & {
  ref?: Ref<HTMLDivElement>;
};

/**
 * AdvicePricesTemplate component
 */
export const AdvicePricesTemplate: FC<AdvicePricesTemplateProps> = ({
  ref,
}) => <AdvicePricing ref={ref} />;
